export default {
  menu: {
    home: 'Home',
    alliance: 'My Alliance',
    mall: 'Pocket Mall',
    me: 'About Us'
  },
  layout: {
    loading: 'Loading',
    trading: 'Transaction in progress, please wait...',
    comingsoon: 'Coming Soon',
    success: 'Success',
    error: 'Failed'
  },
  header: {
    home: 'Home',
    alliance: 'My Alliance',
    mall: 'Pocket Mall',
    about: 'About Us',
    lang: {
      zh: '简体中文',
      zhTW: '繁體中文',
      en: 'English',
      ko: '한국어',
      ja: '日本語'
    }
  },
  period: {
    m5: '5m',
    m15: '15m',
    h1: '1H',
    h4: '4H',
    d1: 'Day',
    w1: 'Week',
    m1: 'Month'
  },
  home: {
    slogan1: 'Grow Your Assets',
    slogan2_part1: 'Start with',
    slogan2_pocket: 'Pocket',
    slogan2_part2: '',
    slogan3: 'Secure · Stable · High Returns',
    explore: 'Explore More',
    alliance_pack: 'Pocket Alliance Package',
    alliance_desc: 'Chance to win collectible cards worth up to ¥5000, receive Pocket Tokens, and enjoy cumulative rewards up to ¥360!',
    join_alliance: 'Join Pocket Alliance',
    mall: 'Pocket Mall',
    mall_desc: 'More than shopping, it is a way to save.',
    ecosystem: 'Strategic Partner - DRS',
    ecosystem_desc: 'Empowering cooperatives and reducing burdens for civil servants.',
    referrer_title: 'Referrer Address',
    referrer_placeholder: 'Please enter the referrer address',
    confirm: 'Confirm'
  },
  alliance: {
    mint_pool: 'Minting Pool',
    token_count: 'TOKEN Amount',
    usdt_total: 'Total USDT',
    open_price: 'Opening Price',
    current_value: 'Current Value',
    static_income: 'Static Income',
    my_token: 'My TOKEN Amount',
    withdraw: 'Withdraw',
    fill_address: 'Fill Address',
    view_receipt: 'View Shipping Info',
    dynamic_income: 'Dynamic Income',
    current_node: 'Current Node',
    large_node: 'Large Node',
    repurchase_count: 'Repurchase Count',
    current_pack: 'Current Package',
    max_return: 'Maximum Return',
    withdrawn_income: 'Withdrawn Income',
    current_income: 'Current Income',
    my_pack: 'My Package',
    referrer_address: 'Referrer Address',
    community_subsidy: 'Community Subsidy',
    buy_node: 'Purchase Node',
    my_team: 'My Team',
    team_pack: 'Team Package',
    team_small_node: 'Team Small Nodes',
    team_large_node: 'Team Large Nodes',
    my_referrals: 'My Referrals',
    node: 'Node',
    date: 'Date',
    small_node: 'Small Node',
    recommend: 'Recommend',
    high_return: 'High Return',
    buy: 'Buy',
    small_node_desc: 'Suitable for individuals, cost-effective, and easy to participate in ecosystem building.',
    large_node_desc: 'Suitable for advanced users, highly rewarding, and easy to participate in ecosystem building.',
    fill_receipt_info: 'Fill Shipping Information',
    select_region: 'Select Region',
    select_address: 'Address',
    receiver: 'Receiver',
    phone: 'Contact Number',
    submit: 'Submit',
    cancel: 'Cancel',
    purchase_node: 'Purchase Node',
    select_node: 'Select the node you wish to purchase',
    your_address: 'Your Shipping Address',
    your_phone: 'Your Contact Number',
    shipping_status: 'Shipping Status',
    shipp: 'Pending Shipment',
    shipped: 'Shipped',
    shipping_method: 'Shipping Method',
    tracking_number: 'Tracking Number',
    close: 'Close',
    postcode: 'Postal Code',
    endvalue: 'Final Earnings',
    copylink: 'Copy Invitation Link',
    fundinfo: 'Details',
    myorder: 'My Orders',
    orderno: 'Order Number',
    getthings: 'Claim',
    geted: 'Claimed',
    gettime: 'Claim Time',
    packamount: 'Package Amount',
    nonode: 'None',
    teamsub: 'Community Subsidy',
    pocketname: 'Pocket Alliance',
    pocketname1: 'Thank you for your support and participation!',
    pocketname2: 'Please visit the designated offline store to claim your product. Wishing you great luck and the chance to win rare collectible cards!',
    nodealert:'Recommendation required',
    nodealert2:'People',
  },
  me: {
    about_alliance: 'About Pocket Alliance',
    alliance_rule1: "Pocket Alliance is an innovative ecosystem alliance centered on Web3, dedicated to building a value ecosystem that integrates consumption appreciation, savings growth, collection value, and financial enhancement.",

alliance_rule2: "We aim to make it simple, understandable, and low-barrier, so that more ordinary people can access and participate in the opportunities of the Web3 era, achieving long-term accumulation and growth of wealth value.",

alliance_rule3: "Pocket Alliance uses tabletop social games as an entry point, building trust and connections among people through fun and interactive experiences; based on community co-creation, we foster a vibrant value network through sharing, learning, and collaboration.",

alliance_rule4: "In the Pocket Alliance ecosystem, consumption is no longer just spending, savings are no longer just deposits, and collecting is no longer just a hobby—it becomes a sustainable value-creating cycle.",

alliance_rule5: "Our Vision",

alliance_rule6: "To ensure everyone has their own value pocket, locking in, accumulating, and passing on wealth in the Web3 era.",

alliance_rule7: "Our Mission",

alliance_rule8: "Connecting value through social interactions and creating growth through the ecosystem, bringing Web3 into every household.",

alliance_rule9: "Our Core Values",

alliance_rule10: "💰 Consumption Appreciation — Making every purchase more valuable",
alliance_rule11: "🏦 Savings Growth — Giving funds the opportunity to grow",
alliance_rule12: "🃏 Collection Value — Turning interests into assets",
alliance_rule13: "📈 Financial Enhancement — Keeping value in continuous circulation",
alliance_rule14: "🤝 Community Co-creation — Making sharing create greater value",
alliance_rule15: "🌐 Web3 Empowerment — Enabling everyone to participate in the future economy",

alliance_rule16: "Pocket Alliance — Turning consumption into assets, social interaction into value, and the future into your pocket.",

alliance_rule17: "Pocket Alliance — Let every member’s pocket be full.",
    about_node: 'About Nodes',
    node_rule1: '1. Invest 300U to become a Small Node.',
    node_rule2: '2. Invest 800U to become a Large Node.',
    pocketname: 'Pocket Token',
    pocketprice: 'Current Market Value',
    pockettrade: 'Trading Volume'
  },
  mall: {
    coming_soon: 'Coming Soon...'
  },
  chart: {
    open: 'Open',
    close: 'Close',
    high: 'High',
    low: 'Low',
    change: 'Change',
    change_rate: 'Change Rate',
    volume: 'Volume'
  }
};